var map = {
	"./20120319_1.jpg": 46235,
	"./20120319_2.jpg": 3436,
	"./20120319_3.jpg": 65161,
	"./20120319_4.jpg": 63322,
	"./20120319_5.jpg": 57783,
	"./20120319_6.jpg": 23560,
	"./20120319_7.jpg": 85925,
	"./20120319_8.jpg": 48534
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68637;